import LayoutViewNested from '../../../../../../views/layouts/nested.html';

/* @ngInject */
export default function ($stateProvider) {
	$stateProvider
		.state('staff.forms.responses.view', {
			abstract: true,
			url:      '/{formId}/responses',
			template: LayoutViewNested,
		});
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/forms/responses/view/router.js